export default Buffer.from("AuBSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TRQEBAADNf3EnAACBfwCBf4IAgX+EAIF/hgCBf4gAgX+KAIF/jACBf44AgX+QAIF/kgCBf5QAgX+WAIF/mACBf5oAgX+cAIF/ngCBf6AAgX+iAIF/pACBf6YAgX+oAIF/qgCBf6wAgX+uAIF/sACBf7IAgX+0AIF/tgCBf7gAgX+6AIF/vACBf74AgX/AAIF/wgCBf8QAgX/GAIF/yACBf8oAgSjMAA==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/Adobe-GB1-1.bcmap
// module id = 595
// module chunks = 502